interface SucesscheckProps {
    className?: string;
  }
  
  const Sucesscheck = (props: SucesscheckProps) => {
    return (

<svg className={`${props.className ? props.className : ""}`} width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5112 21.9072C10.9025 21.9072 10.3242 21.6637 9.89812 21.2376L1.28495 12.6245C0.402331 11.7418 0.402331 10.281 1.28495 9.39834C2.16757 8.51572 3.62846 8.51572 4.51108 9.39834L11.5112 16.3984L27.1549 0.754739C28.0375 -0.127882 29.4984 -0.127882 30.381 0.754739C31.2636 1.63736 31.2636 3.09825 30.381 3.98087L13.1243 21.2376C12.6982 21.6637 12.1199 21.9072 11.5112 21.9072Z" fill="#51C128"/>
</svg>

    );
  };
  
  export default Sucesscheck;
  
